import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.payment
 * @constructor
 */
export class PaymentMethodModel extends BaseModel {
  /**
   * @param {string} type
   * @param {string} name
   * @param {loavies.models.payment.PaymentMethodIssuerModel[]} [issuers]
   * @param {string} [code]
   * @param {string} [key]
   * @param {string} [brand]
   * @param {string[]} [brands]
   * @param {string[]} [supportedNetworks]
   */
  constructor({
    type,
    name,
    issuers,
    code,
    key,
    brand,
    brands,
    supportedNetworks,
  }) {
    super()

    /** @type {string} */
    this.type = type

    /** @type {string} */
    this.name = name

    /** @type {null|loavies.models.payment.PaymentMethodIssuerModel[]} */
    this.issuers = issuers ?? null

    /** @type {string} */
    this.code = code

    /** @type {string} */
    this.key = key

    /** @type {string} */
    this.brand = brand ?? null

    /** @type {null|string[]} */
    this.brands = brands ?? null

    /** @type {null|string[]} */
    this.supportedNetworks = supportedNetworks ?? null
  }
}

// https://docs.adyen.com/payment-methods/cards/custom-card-integration#supported-card-types
export const CREDIT_CARD_NAMES = {
  amex: 'Amex',
  argencard: 'Argencard',
  bcmc: 'Bancontact/Mister Cash',
  bijcard: 'de Bijenkorf Card',
  cabal: 'Cabal',
  cartebancaire: 'Carte Bancaires',
  codensa: 'Codensa',
  cup: 'China Union Pay',
  dankort: 'Dankort',
  diners: 'Diners Club',
  discover: 'Discover',
  electron: 'Electron',
  elo: 'ELO',
  forbrugsforeningen: 'Forbrugsforeningen',
  hiper: 'HiperCard',
  hipercard: 'HiperCard',
  jcb: 'JCB',
  karenmillen: 'Karen Millen GiftCard',
  laser: 'Laser',
  maestro: 'Maestro',
  maestrouk: 'Maestro UK',
  mc: 'Mastercard',
  mcalphabankbonus: 'Alpha Bank Mastercard Bonus',
  mir: 'MIR',
  naranja: 'Naranja',
  oasis: 'Oasis GiftCard',
  rupay: 'RuPay',
  shopping: 'Tarjeta Shopping',
  solo: 'Solo',
  troy: 'Troy',
  uatp: 'UATP',
  visa: 'Visa',
  visaalphabankbonus: 'Alpha Bank Visa Bonus',
  visadankort: 'Visa Dankort',
  warehouse: 'Warehouse GiftCard',
}

/**
 * Adyen Apple Pay brands mapping to supported networks
 * @see https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentrequest/1916122-supportednetworks
 */
export const APPLE_PAY_SUPPORTED_NETWORKS = {
  amex: 'amex',
  cartebancaire: 'cartesBancaires',
  mc: 'masterCard',
  visa: 'visa',
  maestro: 'maestro',
}
